import { genericTableActions } from '../../reducers/genericTable/genericTable';

export const setPageAsClicked = (pageNumber) => {
    return async dispatch => {
        try {
            dispatch(genericTableActions.setPageAsClickedInArray({ 'pageNumber': pageNumber }));
        } catch (error) {
            console.error(error);
        }
    };
};

export const resetClickedPagesArray = () => {
	return async dispatch => {
        try {
            dispatch(genericTableActions.resetClickedPagesArray({}));
        } catch (error) {
            console.error(error);
        }
    };
};

export const setTotalCount = (totalCount) => {
	return async dispatch => {
        try {
            dispatch(genericTableActions.setTotalCount({ 'totalCount': totalCount}));
        } catch (error) {
            console.error(error);
        }
    };
};

// export const setSelectedRow = (selectedRow) => {
// 	return async dispatch => {
//         try {
//             dispatch(genericTableActions.setSelectedRow({ 'selectedRow': selectedRow}));
//         } catch (error) {
//             console.error(error);
//         }
//     };
// };
